var React = require('react');

function IconCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon/circle","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("circle",{"stroke":"#7D7971","fill":"#F9F9F8","cx":"10","cy":"10","r":"9.5"})));
}

IconCircle.defaultProps = {"viewBox":"0 0 20 20","version":"1.1"};

module.exports = IconCircle;

IconCircle.default = IconCircle;
